import { useTheme } from '../../context/ThemeContext';
import { FiSmartphone, FiClock, FiCheckCircle, FiUsers, FiShield, FiArrowRight } from 'react-icons/fi';

const StatsGrid = ({ stats, setActiveTab }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="mb-10 animate-fade-in-up">
      {/* Header section com linha fina (Ocultado para dar mais espaço)
      <div className={`mb-8 pb-4 border-b ${isDarkMode ? 'border-gray-800' : 'border-gray-200'} flex flex-col sm:flex-row sm:items-end justify-between gap-4`}>
        <div>
          <h2 className={`text-2xl sm:text-3xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            System Metrics
          </h2>
          <p className={`text-xs sm:text-sm mt-1 uppercase tracking-widest font-semibold ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
            Overview em Tempo Real
          </p>
        </div>
        <div className="flex items-center gap-2 bg-emerald-500/10 px-3 py-1.5 rounded-full border border-emerald-500/20">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
          </span>
          <span className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">Sistema Online</span>
        </div>
      </div>
      */}

      {/* Grid Assimétrico Neo-Editorial */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6">
        
        {/* HERO CARD - Total Apps */}
        <div 
          onClick={() => setActiveTab && setActiveTab('apps')}
          className={`
            lg:col-span-2 group relative overflow-hidden transition-all duration-500 cursor-pointer
            border ${isDarkMode ? 'border-gray-800 bg-gray-900/50' : 'border-gray-200 bg-white'}
            hover:border-indigo-500/50 hover:shadow-[4px_4px_0px_0px_rgba(99,102,241,0.2)]
          `}
        >
          {/* Fundo decorativo */}
          <div className="absolute -top-6 -right-6 p-8 opacity-[0.03] group-hover:opacity-10 transition-all duration-500 transform group-hover:scale-110 group-hover:rotate-12 pointer-events-none">
            <FiSmartphone size={220} className={isDarkMode ? 'text-white' : 'text-gray-900'} />
          </div>
          
          <div className="p-4 sm:p-6 md:p-8 h-full flex flex-col justify-between relative z-10">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className={`p-2.5 sm:p-3 border ${isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-100 bg-gray-50'}`}>
                  <FiSmartphone className={isDarkMode ? 'text-indigo-400' : 'text-indigo-600'} size={24} />
                </div>
                <span className={`text-xs sm:text-sm font-bold uppercase tracking-widest ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  Total de Aplicativos
                </span>
              </div>
              <p className={`text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                {stats.totalApps}
              </p>
            </div>
            
            <div className={`mt-8 sm:mt-10 pt-6 border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-100'} flex items-center justify-between`}>
              <span className={`text-xs sm:text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Volume geral da plataforma</span>
              <span className="text-indigo-600 dark:text-indigo-400 font-bold flex items-center gap-2 text-sm uppercase tracking-wide">
                Ver todos <FiArrowRight className="transform group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </div>
        </div>

        {/* Secondary Cards Grid */}
        <div className="lg:col-span-2 grid grid-cols-2 gap-3 sm:gap-6">
          
          {/* Pendentes */}
          <div 
            onClick={() => setActiveTab && setActiveTab('apps')}
            className={`
              p-6 group transition-all duration-300 cursor-pointer flex flex-col justify-between
              border ${isDarkMode ? 'border-gray-800 bg-gray-900/30' : 'border-gray-200 bg-gray-50/50'}
              hover:bg-amber-500/5 dark:hover:bg-amber-500/10 hover:border-amber-500/50
              hover:shadow-[4px_4px_0px_0px_rgba(245,158,11,0.2)]
            `}
          >
            <div className="flex justify-between items-start mb-6">
              <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-widest ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Pendentes</span>
              <FiClock className="text-amber-500" size={18} />
            </div>
            <p className={`text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{stats.pendingApps}</p>
          </div>

          {/* Publicados */}
          <div 
            onClick={() => setActiveTab && setActiveTab('apps')}
            className={`
              p-6 group transition-all duration-300 cursor-pointer flex flex-col justify-between
              border ${isDarkMode ? 'border-gray-800 bg-gray-900/30' : 'border-gray-200 bg-gray-50/50'}
              hover:bg-emerald-500/5 dark:hover:bg-emerald-500/10 hover:border-emerald-500/50
              hover:shadow-[4px_4px_0px_0px_rgba(16,185,129,0.2)]
            `}
          >
            <div className="flex justify-between items-start mb-6">
              <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-widest ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Publicados</span>
              <FiCheckCircle className="text-emerald-500" size={18} />
            </div>
            <p className={`text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{stats.publishedApps}</p>
          </div>

          {/* Usuários */}
          <div 
            onClick={() => setActiveTab && setActiveTab('users')}
            className={`
              p-6 group transition-all duration-300 cursor-pointer flex flex-col justify-between
              border ${isDarkMode ? 'border-gray-800 bg-gray-900/30' : 'border-gray-200 bg-gray-50/50'}
              hover:bg-blue-500/5 dark:hover:bg-blue-500/10 hover:border-blue-500/50
              hover:shadow-[4px_4px_0px_0px_rgba(59,130,246,0.2)]
            `}
          >
            <div className="flex justify-between items-start mb-6">
              <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-widest ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Usuários</span>
              <FiUsers className="text-blue-500" size={18} />
            </div>
            <p className={`text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{stats.totalUsers}</p>
          </div>

          {/* Admins */}
          <div 
            onClick={() => setActiveTab && setActiveTab('users')}
            className={`
              p-6 group transition-all duration-300 cursor-pointer flex flex-col justify-between
              border ${isDarkMode ? 'border-gray-800 bg-gray-900/30' : 'border-gray-200 bg-gray-50/50'}
              hover:bg-rose-500/5 dark:hover:bg-rose-500/10 hover:border-rose-500/50
              hover:shadow-[4px_4px_0px_0px_rgba(244,63,94,0.2)]
            `}
          >
            <div className="flex justify-between items-start mb-6">
              <span className={`text-[10px] sm:text-xs font-bold uppercase tracking-widest ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Admins</span>
              <FiShield className="text-rose-500" size={18} />
            </div>
            <p className={`text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{stats.adminUsers}</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default StatsGrid;